import React, { ReactNode } from 'react'

export const Modal = ({ open, setOpen, title  , children}: { open: boolean, setOpen: (state: boolean) => void, title?: string, children: ReactNode }) => {

    if (open)
        return (
            <div onClick={(e) => e.target === e.currentTarget && setOpen(false)} className={`fixed top-0 right-0 bg-modal h-full w-full z-50 flex justify-center items-center ${open ? "flex" : "hidden"}`}>
                <div className={" bg-white rounded-lg p-5 flex flex-col gap-4 items-stretch max-w-[350px]"}>
                    
                    {!!title && <div className={"text-gray-500 text-base ltr:text-left rtl:text-right"}>
                        {title}
                    </div>}

                    {children}

                </div>
            </div>
        )

    return <></>
}
